'use client';
import { Carousel, CarouselContent, CarouselItem } from '../ui/carousel';
import Image from '../Image';
import { useLocale } from 'next-intl';
import RenderDestination from '../helper/RenderDestination';

type NumberOfImages = 'oneImage' | 'twoImages' | 'threeImages' | 'fourImages';

type TProps = {
  sliders: any[];
  className?: string;
  numberOfImages: NumberOfImages;
  showingSectionTitle?: boolean;
  showingSectionDescription?: boolean;
  name?: string;
  description?: string;
};

type ImageConfig = {
  class: string;
  sizes: string;
};

const imageConfig: Record<NumberOfImages, ImageConfig> = {
  oneImage: {
    class: 'basis-1/1 aspect-2/1',
    sizes: '(min-width: 1520px) 1424px, 94.75vw',
  },
  twoImages: {
    class: 'basis-[calc(50%-.5rem)] aspect-2/1',
    sizes: ' (min-width: 1520px) 700px, calc(47.17vw - 8px)',
  },
  threeImages: {
    class: 'basis-[calc(33.333%-.5rem)] aspect-2/1',
    sizes: ' 33vw',
  },
  fourImages: {
    class: `basis-[calc(25%-.5rem)] aspect-square`,
    sizes: '(min-width: 1520px) 322px, 21.67vw',
  },
};

function ImagesCarousel({ sliders, className, numberOfImages }: TProps) {
  const locale = useLocale();
  const config = imageConfig[numberOfImages];

  return (
    <Carousel
      className="w-full"
      opts={{
        slidesToScroll: 'auto',
        dragFree: true,
        direction: locale === 'ar' ? 'rtl' : 'ltr',
      }}
    >
      <CarouselContent className="mx-0 gap-2">
        {sliders.map((item, index) => (
          <CarouselItem
            key={index}
            className={`h-full w-full p-0 ${config.class} ${className ?? ''}`}
          >
            <RenderDestination
              destination={item.Destination}
              destinationValue={item.DestinationValue}
            >
              <div className={`relative h-full w-full overflow-hidden rounded-xl`}>
                <Image
                  fill
                  alt={item.EnglishImage}
                  src={locale === 'ar' ? item.ArabicImage : (item.EnglishImage ?? '')}
                  className={`flex-1 rounded-lg object-cover object-center`}
                  sizes={config.sizes}
                />
              </div>
            </RenderDestination>
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
}

export default ImagesCarousel;
